// extracted by mini-css-extract-plugin
export var askAiIcon = "_kc-9";
export var container = "_kc-0";
export var groupSeparator = "_kc-a";
export var highlight = "_kc-4";
export var resultIcon = "_kc-5";
export var resultItem = "_kc-7";
export var resultSubtitle = "_kc-3";
export var resultTitle = "_kc-2";
export var resultsList = "_kc-1";
export var searchGroup = "_kc-6";
export var selected = "_kc-8";